export const ATS_CONSTANTS = {
  COLORS: {
    SUCCESS: '#10b981',
    ERROR: '#ef4444',
    INFO: '#3b82f6',
    GRAY: '#6b7280',
    WHITE: '#fff',
    PRIMARY: '#005A9C',
    SECONDARY: '#f3f4f6',
    SECONDARY_TEXT: '#374151',
  },
  STATUS: {
    SCHEDULED: 'SCHEDULED',
    RESCHEDULED: 'RESCHEDULED',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
    NO_SHOW: 'NO_SHOW',
    ACCEPTED: 'ACCEPTED',
    SYSTEM_REJECTED: 'SYSTEM_REJECTED',
    EXPIRED: 'EXPIRED',
    VIEWED: 'VIEWED',
    GENERATED: 'GENERATED',
    REJECTED: 'REJECTED',
  },
  COLUMNS: {
    APPLIED: 'applied',
    IN_CONSIDERATION: 'in-consideration',
    ACCEPTED: 'accepted',
    REJECTED: 'rejected',
  },
  INTERVIEW_COLUMNS: {
    ACTION_NEEDED: 'action-needed',
    UPCOMING: 'upcoming',
    COMPLETED: 'completed',
    NO_SHOW: 'no-show',
    CANCELLED: 'cancelled',
  },
  TABS: {
    APPLICATIONS: 'applications',
    INTERVIEWS: 'interviews',
  },
  OFFER_MODES: {
    SINGLE: 'single',
    BULK: 'bulk',
  },
} as const;
